<template>
    <modal :show="showModal"
           body-classes="p-0"
           modal-classes="modal-dialog-centered">
        <card type="secondary" shadow
              header-classes="bg-white pb-2"
              body-classes="px-lg-5 py-lg-5"
              class="border-0">
            <template v-slot:header>
                <h2>Bericht erstellen</h2>
                <div class="text-muted text-center">
                    <small>Erstellen Sie jetzt Ihren Bericht für den aktuellen Berichtszeitraum oder wählen einen eigenen Zeitraum über "Benutzerdefinierter Zeitraum".</small>
                </div>
            </template>
            <ExportSettings :report-data="reportData"></ExportSettings>
        </card>
        <template v-slot:footer>
            <base-button type="secondary" @click="location.id = 0">abbrechen</base-button>
            <base-button type="primary"
                         text-color="white"
                         class="ml-auto"
                         @click="createReport">
                Bericht erstellen
            </base-button>
        </template>
    </modal>
</template>

<script>
    import ExportSettings from "@/components/Report/ExportSettings";
    export default {
         name:"ExportModal",
        components:{ExportSettings},
        props: {
            location: {
                type: Object
            },
            reportCreation: {
                type: Array
            },
            report: {
                type: Object
            }
        },
        data() {
            return {
                reportData: {
                    type: 'default',
                    startsAt: null,
                    endsAt: null,
                    reportType: 'all'
                }
            }
        },
        computed: {
            showModal() {
                return this.location.id !== 0;
            }
        },
        methods: {
            dateToYMD(date) {
                let d = date.getDate();
                let m = date.getMonth() + 1; //Month from 0 to 11
                let y = date.getFullYear();
                return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
            },
            createReport() {
                this.location.reportStatus = "loading";
                return new Promise((resolve, reject) => {
                    this.reportCreation.push(this.location.id);
                    this.key++;
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header
                    };

                    let loc = this.location.id;
                    //close modal
                    this.location.id = 0;

                    //define url
                    let d = new Date();
                    let year = d.getFullYear();
                    let month = d.getMonth();
                    let day = d.getDate()+1;
                    let start = new Date(year, month, 1);
                    let end = new Date(year, month, day);
                    let url = "url";
                    let base = `/report/create/`;

                    switch (this.reportData.reportType) {
                        case 'all':
                            base = `/report/create/`;
                            break;
                        case 'activities':
                            base = `/report/create/activity/`;
                            break;
                        case 'oasis':
                            base = `/report/create/lockrequests/`;
                            break;
                        case 'tasks':
                            base = `/report/create/tasks/`;
                            break;
                        default:
                            base = `/report/create/`;
                            break;
                    }
                    
                    
                    switch (this.reportData.type) {
                        case "default":
                            url = process.env.VUE_APP_API_SERVER + base + loc;
                            break;
                        case "custom":
                            url = process.env.VUE_APP_API_SERVER + base + loc  + `/` + this.reportData.startsAt + `/` + this.reportData.endsAt;
                            break;
                        case "actmonth":
                            start = new Date(year, month, 1);
                            end = new Date(year, month, day);
                            url = process.env.VUE_APP_API_SERVER + base + loc  + `/` + this.dateToYMD(start) + `/` + this.dateToYMD(end);
                            break;
                        case "lastmonth":
                            start = new Date(year, month-1, 1);
                            end = new Date(year, month, 0);
                            url = process.env.VUE_APP_API_SERVER + base + loc  + `/` + this.dateToYMD(start) + `/` + this.dateToYMD(end);
                            break;
                        case "lastyear":
                            start = new Date(year-1, 0, 1);
                            end = new Date(year-1, 12, 0);
                            url = process.env.VUE_APP_API_SERVER + base + loc  + `/` + this.dateToYMD(start) + `/` + this.dateToYMD(end);
                            break;
                        case "actyear":
                            start = new Date(year, 0, 1);
                            end = new Date(year, month, day);
                            url = process.env.VUE_APP_API_SERVER + base + loc  + `/` + this.dateToYMD(start) + `/` + this.dateToYMD(end);
                            break;
                        default:
                            url = process.env.VUE_APP_API_SERVER + `/report/create/` + loc;
                            break;
                    }



                    fetch(url, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                            this.report.id = response.id;
                            this.report.periodStartsAt = response.periodStartsAt;
                            this.report.periodEndsAt = response.periodEndsAt;
                            this.report.status = response.status;
                            this.report.location = response.location;
                            this.report.createdAt = response.createdAt;
                            this.report.customer = response.customer;
                            this.report.publicPath = response.publicPath;
                            this.location.reportStatus = 'success';
                            this.$store.dispatch('alert/clear');
                            this.reportCreation.splice(this.reportCreation.indexOf(loc),1);
                            this.key++;
                            this.$emit('reportcreated',response);
                            resolve({
                                member: response
                            });
                        }, error => {
                            if (error.name === "TypeError") {
                                this.$store.dispatch('alert/warn',"Möglicherweise dauert die Berichterstellung länger. Wir benachrichtigen Sie, sobald der Report fertig ist.");
                            } else {
                                this.location.reportStatus = "error";
                                this.$store.dispatch('alert/error',error);
                            }
                            this.reportCreation.splice(this.reportCreation.indexOf(loc),1);
                            this.key++;
                            reject(error); });
                });
            }
        }
    }
</script>

<style scoped>

</style>